import { FC } from "react";
import { FieldWidth, Field } from "./FormSection.props";
import Grid from "../Grid";
import { TextField } from "../FormElements";
import { useFormContext } from "../Form";
import * as validate from "../FormElements/validation";

/**
 * @deprecated
 */
export const FormSectionTextField: FC<Field> = ({ name, label, defaultValue, required, validator, isEditable, width }: Field) => {
  const { readOnly } = useFormContext();

  let useRequired = required;
  let useValidator = validator;

  if (useRequired === undefined) {
    useRequired = validate.required;
  } else {
    if (useRequired.value === false) {
      useValidator = (val: validate.Validatable) => {
        if (val !== undefined && val.length) {
          return validator(val);
        } else {
          return true;
        }
      };
    }
  }

  return (
    <Grid item colLg={width === FieldWidth.HALF ? 6 : 12} id="form-grid-item">
      <TextField
        id={name}
        labelText={label}
        name={name}
        readOnly={readOnly || !isEditable}
        validate={{ required: useRequired, validate: useValidator }}
        defaultValue={defaultValue}
      />
    </Grid>
  );
};
